import proxy from '@pro/proxy-host.json';

const regexp = /^(\[(\d+)\])?(.+)$/;
const matched = regexp.exec(proxy || '');

const proxyInfo = {
  projectId: matched?.[2] || '',
  proxyHost: matched?.[3] || ''
};

export const projectId = proxyInfo.projectId;
export const proxyHost = proxyInfo.proxyHost;
export default proxyInfo;
